import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-62.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Single User Example", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", { class: "d-sm-flex justify-content-between align-items-center" }, [
            _createElementVNode("div", { class: "d-flex align-items-center mb-3 mb-sm-0" }, [
              _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "wh-60 rounded-circle",
                  alt: "user"
                })
              ]),
              _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                _createElementVNode("h4", { class: "fs-16 fw-semibold mb-1" }, "Andrew Burns"),
                _createElementVNode("span", { class: "fs-14" }, "Programmer")
              ])
            ]),
            _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled d-flex gap-2" }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "https://www.facebook.com/",
                  target: "_blank",
                  class: "text-decoration-none wh-40 bg-primary bg-opacity-10 d-block text-center position-relative rounded-circle text-primary hover-bg"
                }, [
                  _createElementVNode("i", { class: "ri-facebook-fill position-absolute top-50 start-50 translate-middle fs-18" })
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "https://www.facebook.com/",
                  target: "_blank",
                  class: "text-decoration-none wh-40 bg-primary bg-opacity-10 d-block text-center position-relative rounded-circle text-primary hover-bg"
                }, [
                  _createElementVNode("i", { class: "ri-twitter-x-line position-absolute top-50 start-50 translate-middle fs-18" })
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "https://www.facebook.com/",
                  target: "_blank",
                  class: "text-decoration-none wh-40 bg-primary bg-opacity-10 d-block text-center position-relative rounded-circle text-primary hover-bg"
                }, [
                  _createElementVNode("i", { class: "ri-linkedin-fill position-absolute top-50 start-50 translate-middle fs-18" })
                ])
              ])
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "basicAlertsCode"
            }, "\n<div class=\"card bg-white border-0 rounded-3 mb-4\">\n<div class=\"card-body p-4\">\n<h4 class=\"fs-18 mb-4\">Single User Example</h4>\n<div class=\"d-sm-flex justify-content-between align-items-center\">\n<div class=\"d-flex align-items-center mb-3 mb-sm-0\">\n<div class=\"flex-shrink-0\">\n<img src=\"@/assets/images/user-62.jpg\" class=\"wh-60 rounded-circle\" alt=\"user\">\n</div>\n<div class=\"flex-grow-1 ms-3\">\n<h4 class=\"fs-16 fw-semibold mb-1\">Andrew Burns</h4>\n<span class=\"fs-14\">Programmer</span>\n</div>\n</div>\n<ul class=\"ps-0 mb-0 list-unstyled d-flex gap-2\">\n<li>\n<a href=\"https://www.facebook.com/\" target=\"_blank\" class=\"text-decoration-none wh-40 bg-primary bg-opacity-10 d-block\ntext-center position-relative rounded-circle text-primary hover-bg\">\n<i class=\"ri-facebook-fill position-absolute top-50 start-50 translate-middle fs-18\"></i>\n</a>\n</li>\n<li>\n<a href=\"https://www.facebook.com/\" target=\"_blank\" class=\"text-decoration-none wh-40 bg-primary bg-opacity-10 d-block\ntext-center position-relative rounded-circle text-primary hover-bg\">\n<i class=\"ri-twitter-x-line position-absolute top-50 start-50 translate-middle fs-18\"></i>\n</a>\n</li>\n<li>\n<a href=\"https://www.facebook.com/\" target=\"_blank\" class=\"text-decoration-none wh-40 bg-primary bg-opacity-10 d-block\ntext-center position-relative rounded-circle text-primary hover-bg\">\n<i class=\"ri-linkedin-fill position-absolute top-50 start-50 translate-middle fs-18\"></i>\n</a>\n</li>\n</ul>\n</div>\n</div>\n</div>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}